import { Union, Record } from "./fable_modules/fable-library.3.7.20/Types.js";
import { int32_type, union_type, record_type, string_type } from "./fable_modules/fable-library.3.7.20/Reflection.js";
import { toText, replace, printf, toFail } from "./fable_modules/fable-library.3.7.20/String.js";
import { ofArray } from "./fable_modules/fable-library.3.7.20/List.js";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library.3.7.20/Seq.js";
import { int32ToString, equals } from "./fable_modules/fable-library.3.7.20/Util.js";
import { parse } from "./fable_modules/fable-library.3.7.20/Int32.js";

export class IsoCountryCode extends Record {
    constructor(ThreeLetter, TwoLetter) {
        super();
        this.ThreeLetter = ThreeLetter;
        this.TwoLetter = TwoLetter;
    }
}

export function IsoCountryCode$reflection() {
    return record_type("DomainTypes.IsoCountryCode", [], IsoCountryCode, () => [["ThreeLetter", string_type], ["TwoLetter", string_type]]);
}

export class IsoCurrencyCode extends Record {
    constructor(Code) {
        super();
        this.Code = Code;
    }
}

export function IsoCurrencyCode$reflection() {
    return record_type("DomainTypes.IsoCurrencyCode", [], IsoCurrencyCode, () => [["Code", string_type]]);
}

export class PaymentMethod extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Invoice", "Card", "Payflow"];
    }
}

export function PaymentMethod$reflection() {
    return union_type("DomainTypes.PaymentMethod", [], PaymentMethod, () => [[], [], []]);
}

export function PaymentMethodModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "CARD";
        }
        case 2: {
            return "PAYFLOW";
        }
        default: {
            return "INVOICE";
        }
    }
}

export function PaymentMethodModule_ofString(str) {
    const matchValue = str.trim().toLocaleUpperCase();
    switch (matchValue) {
        case "INVOICE": {
            return new PaymentMethod(0);
        }
        case "CARD": {
            return new PaymentMethod(1);
        }
        case "PAYFLOW": {
            return new PaymentMethod(2);
        }
        default: {
            return toFail(printf("Could not parse string \u0027%s\u0027 to PaymentMethod."))(matchValue);
        }
    }
}

export function PaymentMethodModule_getOptions(getTranslation) {
    return ofArray([[PaymentMethodModule_toString(new PaymentMethod(0)), getTranslation("Common.Invoice")], [PaymentMethodModule_toString(new PaymentMethod(1)), getTranslation("DomainTypes.PaymentMethod.Card")]]);
}

export function PaymentMethodModule_toTranslation(getTranslation, _arg) {
    switch (_arg.tag) {
        case 1: {
            return getTranslation("DomainTypes.PaymentMethod.Card");
        }
        case 2: {
            return getTranslation("DomainTypes.PaymentMethod.Payflow");
        }
        default: {
            return getTranslation("Common.Invoice");
        }
    }
}

export class InvoiceeType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Private", "Company"];
    }
}

export function InvoiceeType$reflection() {
    return union_type("DomainTypes.InvoiceeType", [], InvoiceeType, () => [[], []]);
}

export function InvoiceeTypeModule_toString(_arg) {
    if (_arg.tag === 1) {
        return "COMPANY";
    }
    else {
        return "PRIVATE";
    }
}

export function InvoiceeTypeModule_ofStringSafe(str) {
    const matchValue = str.trim().toLocaleUpperCase();
    switch (matchValue) {
        case "PRIVATE": {
            return new InvoiceeType(0);
        }
        case "COMPANY": {
            return new InvoiceeType(1);
        }
        default: {
            return void 0;
        }
    }
}

export function InvoiceeTypeModule_ofString(str) {
    const matchValue = InvoiceeTypeModule_ofStringSafe(str);
    if (matchValue == null) {
        return toFail(printf("Could not parse string \u0027%s\u0027 to InvoiceeType."))(str);
    }
    else {
        return matchValue;
    }
}

export function InvoiceeTypeModule_getOptions(getTranslation) {
    return ofArray([[InvoiceeTypeModule_toString(new InvoiceeType(0)), getTranslation("DomainTypes.InvoiceeType.Private")], [InvoiceeTypeModule_toString(new InvoiceeType(1)), getTranslation("DomainTypes.InvoiceeType.Company")]]);
}

export function InvoiceeTypeModule_toOrgHeader(getTranslation, _arg) {
    if (_arg.tag === 1) {
        return getTranslation("DomainTypes.InvoiceeType.OrgNr");
    }
    else {
        return getTranslation("DomainTypes.InvoiceeType.SSN");
    }
}

export function InvoiceeTypeModule_toTranslation(getTranslation, _arg) {
    if (_arg.tag === 1) {
        return getTranslation("DomainTypes.InvoiceeType.Company");
    }
    else {
        return getTranslation("DomainTypes.InvoiceeType.Private");
    }
}

export function InvoiceeTypeModule_ofInt(_arg) {
    switch (_arg) {
        case 0: {
            return new InvoiceeType(0);
        }
        case 1: {
            return new InvoiceeType(1);
        }
        default: {
            return toFail(printf("Could not convert int \u0027%i\u0027 to InvoiceeType."))(_arg);
        }
    }
}

export function InvoiceeTypeModule_toCode(_arg) {
    if (_arg.tag === 1) {
        return 1;
    }
    else {
        return 0;
    }
}

export class Distribution extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Mail", "Email", "EInvoice", "EHFInvoice", "Peppol", "Digipost", "Unknown"];
    }
}

export function Distribution$reflection() {
    return union_type("DomainTypes.Distribution", [], Distribution, () => [[], [], [], [], [], [], []]);
}

export function DistributionModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "Email";
        }
        case 2: {
            return "EInvoice";
        }
        case 3: {
            return "EHFInvoice";
        }
        case 4: {
            return "Peppol";
        }
        case 5: {
            return "Digipost";
        }
        case 6: {
            return "Unknown";
        }
        default: {
            return "Mail";
        }
    }
}

export function DistributionModule_ofString(_arg) {
    switch (_arg) {
        case "Mail": {
            return new Distribution(0);
        }
        case "Email": {
            return new Distribution(1);
        }
        case "EInvoice": {
            return new Distribution(2);
        }
        case "EHFInvoice": {
            return new Distribution(3);
        }
        case "Peppol": {
            return new Distribution(4);
        }
        case "Digipost": {
            return new Distribution(5);
        }
        case "Unknown": {
            return new Distribution(6);
        }
        default: {
            return new Distribution(6);
        }
    }
}

export function DistributionModule_ofCode(_arg) {
    switch (_arg) {
        case 1: {
            return new Distribution(0);
        }
        case 2: {
            return new Distribution(1);
        }
        case 3: {
            return new Distribution(2);
        }
        case 4: {
            return new Distribution(3);
        }
        case 6: {
            return new Distribution(4);
        }
        case 7: {
            return new Distribution(5);
        }
        default: {
            return new Distribution(6);
        }
    }
}

export function DistributionModule_toCode(_arg) {
    switch (_arg.tag) {
        case 1: {
            return 2;
        }
        case 2: {
            return 3;
        }
        case 3: {
            return 4;
        }
        case 4: {
            return 6;
        }
        case 5: {
            return 7;
        }
        case 6: {
            return -1;
        }
        default: {
            return 1;
        }
    }
}

export function DistributionModule_toTranslation(getTranslation, _arg) {
    switch (_arg.tag) {
        case 1: {
            return getTranslation("DomainTypes.Distribution.Email");
        }
        case 2: {
            return getTranslation("DomainTypes.Distribution.EInvoice");
        }
        case 3: {
            return getTranslation("DomainTypes.Distribution.EHFInvoice");
        }
        case 4: {
            return getTranslation("DomainTypes.Distribution.Peppol");
        }
        case 5: {
            return getTranslation("DomainTypes.Distribution.Digipost");
        }
        case 6: {
            return getTranslation("DomainTypes.Distribution.Unknown");
        }
        default: {
            return getTranslation("DomainTypes.Distribution.Mail");
        }
    }
}

export function DistributionModule_getOptions(getTranslation, countryCode, invoiceeType, usesPeppol, enableEInvoiceIdentifier) {
    if (countryCode.ThreeLetter === "NOR") {
        return toList(delay(() => append(singleton([DistributionModule_toString(new Distribution(0)), DistributionModule_toTranslation(getTranslation, new Distribution(0))]), delay(() => append(singleton([DistributionModule_toString(new Distribution(1)), DistributionModule_toTranslation(getTranslation, new Distribution(1))]), delay(() => (enableEInvoiceIdentifier ? singleton([DistributionModule_toString(new Distribution(2)), DistributionModule_toTranslation(getTranslation, new Distribution(2))]) : empty())))))));
    }
    else {
        return toList(delay(() => append(singleton([DistributionModule_toString(new Distribution(0)), DistributionModule_toTranslation(getTranslation, new Distribution(0))]), delay(() => append(singleton([DistributionModule_toString(new Distribution(1)), DistributionModule_toTranslation(getTranslation, new Distribution(1))]), delay(() => append((equals(invoiceeType, new InvoiceeType(1)) && usesPeppol) ? singleton([DistributionModule_toString(new Distribution(4)), DistributionModule_toTranslation(getTranslation, new Distribution(4))]) : empty(), delay(() => (enableEInvoiceIdentifier ? singleton([DistributionModule_toString(new Distribution(2)), DistributionModule_toTranslation(getTranslation, new Distribution(2))]) : empty())))))))));
    }
}

export class VatMode extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["IncludingVat", "ExcludingVat"];
    }
}

export function VatMode$reflection() {
    return union_type("DomainTypes.VatMode", [], VatMode, () => [[], []]);
}

export function VatModeModule_toString(_arg) {
    if (_arg.tag === 1) {
        return "ExcludingVat";
    }
    else {
        return "IncludingVat";
    }
}

export function VatModeModule_ofString(_arg) {
    switch (_arg) {
        case VatModeModule_toString(new VatMode(0)): {
            return new VatMode(0);
        }
        case VatModeModule_toString(new VatMode(1)): {
            return new VatMode(1);
        }
        default: {
            return toFail(printf("Could not parse string \u0027%s\u0027 to VatMode."))(_arg);
        }
    }
}

export function VatModeModule_toExclVat(_arg) {
    if (_arg.tag === 1) {
        return true;
    }
    else {
        return false;
    }
}

export function VatModeModule_ofExclVat(_arg) {
    if (_arg) {
        return new VatMode(1);
    }
    else {
        return new VatMode(0);
    }
}

export function VatModeModule_getOptions(getTranslation) {
    return ofArray([[VatModeModule_toString(new VatMode(1)), getTranslation("DomainTypes.VatMode.VatExcl")], [VatModeModule_toString(new VatMode(0)), getTranslation("DomainTypes.VatMode.VatIncl")]]);
}

export function VatModeModule_toTranslation(getTranslation, _arg) {
    if (_arg.tag === 1) {
        return getTranslation("DomainTypes.VatMode.VatExcl");
    }
    else {
        return getTranslation("DomainTypes.VatMode.VatIncl");
    }
}

export class Period extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Once", "Monthly", "MonthlyDate", "Monthly3", "Monthly6", "Monthly12", "QuarterlyDate", "HalfYearDate", "YearlyDate", "PerInvoice"];
    }
}

export function Period$reflection() {
    return union_type("DomainTypes.Period", [], Period, () => [[], [], [], [], [], [], [], [], [], []]);
}

export function PeriodModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "MONTH";
        }
        case 2: {
            return "MONTHLY_DATE";
        }
        case 3: {
            return "MONTHLY_3";
        }
        case 4: {
            return "MONTHLY_6";
        }
        case 5: {
            return "MONTHLY_12";
        }
        case 6: {
            return "QUARTERLY_DATE";
        }
        case 7: {
            return "HALF_YEAR_DATE";
        }
        case 8: {
            return "YEARLY_DATE";
        }
        case 9: {
            return "PER_INVOICE";
        }
        default: {
            return "ONCE";
        }
    }
}

export function PeriodModule_ofString(s) {
    const matchValue = replace(s.toLocaleUpperCase(), " ", "");
    switch (matchValue) {
        case "ONCE": {
            return new Period(0);
        }
        case "MONTH":
        case "MONTHLY": {
            return new Period(1);
        }
        case "MONTHLY_DATE": {
            return new Period(2);
        }
        case "MONTHLY3":
        case "MONTHLY_3": {
            return new Period(3);
        }
        case "MONTHLY6":
        case "MONTHLY_6": {
            return new Period(4);
        }
        case "MONTHLY12":
        case "MONTHLY_12": {
            return new Period(5);
        }
        case "QUARTER":
        case "QUARTERLY":
        case "QUARTERLY_DATE": {
            return new Period(6);
        }
        case "HALF YEAR":
        case "HALF_YEAR":
        case "HALF_YEAR_DATE": {
            return new Period(7);
        }
        case "YEAR":
        case "YEARLY":
        case "YEARLY_DATE": {
            return new Period(8);
        }
        case "PER INVOICE":
        case "PER_INVOICE":
        case "PERINVOICE": {
            return new Period(9);
        }
        default: {
            return toFail(printf("[Period.ofString] Cannot parse \u0027%s\u0027 to Period."))(matchValue);
        }
    }
}

export function PeriodModule_ofPeriod(period) {
    switch (period) {
        case 0: {
            return new Period(0);
        }
        case 1: {
            return new Period(1);
        }
        case 3:
        case 25: {
            return new Period(6);
        }
        case 6:
        case 26: {
            return new Period(7);
        }
        case 12:
        case 27: {
            return new Period(8);
        }
        case 21: {
            return new Period(2);
        }
        case 22: {
            return new Period(3);
        }
        case 23: {
            return new Period(4);
        }
        case 24: {
            return new Period(5);
        }
        case 255: {
            return new Period(9);
        }
        default: {
            return toFail(printf("[Period.ofPeriod] Cannot create Period from (period = %i)."))(period);
        }
    }
}

export function PeriodModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1: {
            return 1;
        }
        case 2: {
            return 21;
        }
        case 3: {
            return 22;
        }
        case 4: {
            return 23;
        }
        case 5: {
            return 24;
        }
        case 6: {
            return 25;
        }
        case 7: {
            return 26;
        }
        case 8: {
            return 27;
        }
        case 9: {
            return 255;
        }
        default: {
            return 0;
        }
    }
}

export function PeriodModule_toTranslation(getTranslation, _arg) {
    switch (_arg.tag) {
        case 1: {
            return getTranslation("DomainTypes.Period.MonthlyFee");
        }
        case 2: {
            return getTranslation("DomainTypes.Period.MonthlyDateFee");
        }
        case 3: {
            return getTranslation("DomainTypes.Period.MonthlyWith3MonthsInvoice");
        }
        case 4: {
            return getTranslation("DomainTypes.Period.MonthlyWith6MonthsInvoice");
        }
        case 5: {
            return getTranslation("DomainTypes.Period.MonthlyWith12MonthsInvoice");
        }
        case 6: {
            return getTranslation("DomainTypes.Period.QuarterlyFee");
        }
        case 7: {
            return getTranslation("DomainTypes.Period.HalfYearFee");
        }
        case 8: {
            return getTranslation("DomainTypes.Period.YearlyFee");
        }
        case 9: {
            return getTranslation("DomainTypes.Period.PerInvoice");
        }
        default: {
            return getTranslation("DomainTypes.Period.OneTimeFee");
        }
    }
}

export function PeriodModule_toStringTranslation(getTranslation, period) {
    return [PeriodModule_toString(period), PeriodModule_toTranslation(getTranslation, period)];
}

export function PeriodModule_getOptions(getTranslation) {
    return ofArray([[PeriodModule_toString(new Period(0)), PeriodModule_toTranslation(getTranslation, new Period(0))], [PeriodModule_toString(new Period(1)), PeriodModule_toTranslation(getTranslation, new Period(1))], [PeriodModule_toString(new Period(9)), PeriodModule_toTranslation(getTranslation, new Period(9))]]);
}

export function PeriodModule_getOptionsV1Contracts(getTranslation) {
    return ofArray([[PeriodModule_toString(new Period(0)), PeriodModule_toTranslation(getTranslation, new Period(0))], [PeriodModule_toString(new Period(1)), PeriodModule_toTranslation(getTranslation, new Period(1))]]);
}

export function PeriodModule_getOptionsV2(feeConfig) {
    return toList(delay(() => append(feeConfig.OneTime ? singleton(new Period(0)) : empty(), delay(() => append(feeConfig.Monthly ? singleton(new Period(1)) : empty(), delay(() => append(feeConfig.MonthlyDate ? singleton(new Period(2)) : empty(), delay(() => append(feeConfig.MonthlyWith3MonthsInvoice ? singleton(new Period(3)) : empty(), delay(() => append(feeConfig.MonthlyWith6MonthsInvoice ? singleton(new Period(4)) : empty(), delay(() => append(feeConfig.MonthlyWith12MonthsInvoice ? singleton(new Period(5)) : empty(), delay(() => append(feeConfig.QuarterlyDate ? singleton(new Period(6)) : empty(), delay(() => append(feeConfig.HalfYearDate ? singleton(new Period(7)) : empty(), delay(() => append(feeConfig.YearlyDate ? singleton(new Period(8)) : empty(), delay(() => (feeConfig.PerInvoice ? singleton(new Period(9)) : empty())))))))))))))))))))));
}

export class CancelDateChoice extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Ongoing", "EndDate", "AfterSomeTime"];
    }
}

export function CancelDateChoice$reflection() {
    return union_type("DomainTypes.CancelDateChoice", [], CancelDateChoice, () => [[], [], []]);
}

export function CancelDateChoiceModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "EndDate";
        }
        case 2: {
            return "AfterSomeTime";
        }
        default: {
            return "Ongoing";
        }
    }
}

export function CancelDateChoiceModule_ofString(_arg) {
    switch (_arg) {
        case CancelDateChoiceModule_toString(new CancelDateChoice(0)): {
            return new CancelDateChoice(0);
        }
        case CancelDateChoiceModule_toString(new CancelDateChoice(1)): {
            return new CancelDateChoice(1);
        }
        case CancelDateChoiceModule_toString(new CancelDateChoice(2)): {
            return new CancelDateChoice(2);
        }
        default: {
            return toFail(printf("Cannot parse CancelDateChoice: %s"))(_arg);
        }
    }
}

export class Product extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Mobile", "Fixed", "VoIP", "MobileBroadband", "Broadband", "Electricity", "Other"];
    }
}

export function Product$reflection() {
    return union_type("DomainTypes.Product", [], Product, () => [[], [], [], [], [], [], []]);
}

export function ProductModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "Fixed";
        }
        case 2: {
            return "VoIP";
        }
        case 3: {
            return "MobileBroadband";
        }
        case 4: {
            return "Broadband";
        }
        case 5: {
            return "Electricity";
        }
        case 6: {
            return "Other";
        }
        default: {
            return "Mobile";
        }
    }
}

export function ProductModule_fromString(_arg) {
    switch (_arg) {
        case ProductModule_toString(new Product(0)): {
            return new Product(0);
        }
        case ProductModule_toString(new Product(1)): {
            return new Product(1);
        }
        case ProductModule_toString(new Product(2)): {
            return new Product(2);
        }
        case ProductModule_toString(new Product(3)): {
            return new Product(3);
        }
        case ProductModule_toString(new Product(4)): {
            return new Product(4);
        }
        case ProductModule_toString(new Product(5)): {
            return new Product(5);
        }
        default: {
            return new Product(6);
        }
    }
}

export function ProductModule_ofInt(_arg) {
    switch (_arg) {
        case 0: {
            return new Product(0);
        }
        case 1: {
            return new Product(1);
        }
        case 2: {
            return new Product(2);
        }
        case 3: {
            return new Product(3);
        }
        case 5: {
            return new Product(4);
        }
        case 9: {
            return new Product(5);
        }
        default: {
            return new Product(6);
        }
    }
}

export function ProductModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1: {
            return 1;
        }
        case 2: {
            return 2;
        }
        case 3: {
            return 3;
        }
        case 4: {
            return 5;
        }
        case 5: {
            return 9;
        }
        case 6: {
            return 10;
        }
        default: {
            return 0;
        }
    }
}

export function ProductModule_toTranslation(getTranslation, _arg) {
    switch (_arg.tag) {
        case 1: {
            return getTranslation("ProductType.Fixed");
        }
        case 2: {
            return getTranslation("ProductType.Voip");
        }
        case 3: {
            return getTranslation("ProductType.MobileBroadband");
        }
        case 4: {
            return getTranslation("ProductType.Broadband");
        }
        case 5: {
            return getTranslation("ProductType.Electricity");
        }
        case 6: {
            return getTranslation("ProductType.Other");
        }
        default: {
            return getTranslation("ProductType.Mobile");
        }
    }
}

export function ProductModule_getAllProducts(getTranslation) {
    return ofArray([[ProductModule_toString(new Product(0)), getTranslation("ProductType.Mobile")], [ProductModule_toString(new Product(1)), getTranslation("ProductType.Fixed")], [ProductModule_toString(new Product(2)), getTranslation("ProductType.Voip")], [ProductModule_toString(new Product(3)), getTranslation("ProductType.MobileBroadband")], [ProductModule_toString(new Product(4)), getTranslation("ProductType.Broadband")], [ProductModule_toString(new Product(5)), getTranslation("ProductType.Electricity")], [ProductModule_toString(new Product(6)), getTranslation("ProductType.Other")]]);
}

export class ContractCurrentState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Active", "ActiveWithEndDate", "Pending", "Cancelled", "Inconsistent"];
    }
}

export function ContractCurrentState$reflection() {
    return union_type("DomainTypes.ContractCurrentState", [], ContractCurrentState, () => [[], [], [], [], []]);
}

export function ContractCurrentStateModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "Active with enddate";
        }
        case 2: {
            return "Pending";
        }
        case 3: {
            return "Cancelled";
        }
        case 4: {
            return "Inconsistent";
        }
        default: {
            return "Active";
        }
    }
}

export function ContractCurrentStateModule_fromString(_arg) {
    switch (_arg) {
        case "Active": {
            return new ContractCurrentState(0);
        }
        case "Active with enddate": {
            return new ContractCurrentState(1);
        }
        case "Pending": {
            return new ContractCurrentState(2);
        }
        case "Cancelled": {
            return new ContractCurrentState(3);
        }
        case "Inconsistent": {
            return new ContractCurrentState(4);
        }
        default: {
            return toFail(printf("Cannot parse ContractCurrentState: %s"))(_arg);
        }
    }
}

export function ContractCurrentStateModule_toTranslation(getTranslation, _arg) {
    switch (_arg.tag) {
        case 1: {
            return getTranslation("Common.ActiveWithEndDate");
        }
        case 2: {
            return getTranslation("Common.Pending");
        }
        case 3: {
            return getTranslation("Common.Cancelled");
        }
        case 4: {
            return getTranslation("Common.Inconsistent");
        }
        default: {
            return getTranslation("Common.Active");
        }
    }
}

export class InportingState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Creating", "Created", "Denied", "Approved", "Ordering", "Ordered", "Ported", "Activated", "Done", "Cancelling", "Cancelled", "Failed"];
    }
}

export function InportingState$reflection() {
    return union_type("DomainTypes.InportingState", [], InportingState, () => [[], [], [], [], [], [], [], [], [], [], [], []]);
}

export function InportingStateModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "Created";
        }
        case 2: {
            return "Denied";
        }
        case 3: {
            return "Approved";
        }
        case 4: {
            return "Ordering";
        }
        case 5: {
            return "Ordered";
        }
        case 6: {
            return "Ported";
        }
        case 7: {
            return "Activated";
        }
        case 8: {
            return "Done";
        }
        case 9: {
            return "Cancelling";
        }
        case 10: {
            return "Cancelled";
        }
        case 11: {
            return "Failed";
        }
        default: {
            return "Creating";
        }
    }
}

export function InportingStateModule_fromString(str) {
    const matchValue = str.toLocaleUpperCase();
    switch (matchValue) {
        case "CREATING": {
            return new InportingState(0);
        }
        case "CREATED": {
            return new InportingState(1);
        }
        case "DENIED": {
            return new InportingState(2);
        }
        case "APPROVED": {
            return new InportingState(3);
        }
        case "ORDERING": {
            return new InportingState(4);
        }
        case "ORDERED": {
            return new InportingState(5);
        }
        case "PORTED": {
            return new InportingState(6);
        }
        case "ACTIVATED": {
            return new InportingState(7);
        }
        case "DONE": {
            return new InportingState(8);
        }
        case "CANCELLING": {
            return new InportingState(9);
        }
        case "CANCELLED": {
            return new InportingState(10);
        }
        case "FAILED": {
            return new InportingState(11);
        }
        default: {
            return toFail(printf("[InportingState.fromString] Can not parse: %s"))(matchValue);
        }
    }
}

export class OutportingState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Queried", "Denied", "Allowed", "Waiting", "Processing", "Ported", "Done", "Failed", "Deactivated", "Cancelling", "Cancelled", "Unknown"];
    }
}

export function OutportingState$reflection() {
    return union_type("DomainTypes.OutportingState", [], OutportingState, () => [[], [], [], [], [], [], [], [], [], [], [], []]);
}

export function OutportingStateModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "Denied";
        }
        case 2: {
            return "Allowed";
        }
        case 3: {
            return "Waiting";
        }
        case 4: {
            return "Processing";
        }
        case 5: {
            return "Ported";
        }
        case 6: {
            return "Done";
        }
        case 7: {
            return "Failed";
        }
        case 8: {
            return "Deactivated";
        }
        case 9: {
            return "Cancelling";
        }
        case 10: {
            return "Cancelled";
        }
        case 11: {
            return "Unknown";
        }
        default: {
            return "Queried";
        }
    }
}

export function OutportingStateModule_fromString(str) {
    const matchValue = str.toLocaleUpperCase();
    switch (matchValue) {
        case "QUERIED": {
            return new OutportingState(0);
        }
        case "DENIED": {
            return new OutportingState(1);
        }
        case "ALLOWED": {
            return new OutportingState(2);
        }
        case "WAITING": {
            return new OutportingState(3);
        }
        case "PROCESSING": {
            return new OutportingState(4);
        }
        case "PORTED": {
            return new OutportingState(5);
        }
        case "DONE": {
            return new OutportingState(6);
        }
        case "FAILED": {
            return new OutportingState(7);
        }
        case "DEACTIVATED": {
            return new OutportingState(8);
        }
        case "CANCELLING": {
            return new OutportingState(9);
        }
        case "CANCELLED": {
            return new OutportingState(10);
        }
        case "UNKNOWN": {
            return new OutportingState(11);
        }
        default: {
            return toFail(printf("[OutportingState.fromString] Can not parse: %s"))(matchValue);
        }
    }
}

export class PortationStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Activated", "ActivationStarted", "CancellationStarted", "CancelOk", "CancelNotOk", "Cancelled", "ChangeOk", "ChangeNotOk", "ChangeStarted", "Changed", "Old", "Ordered", "OrderOk", "OrderStarted", "InquiryStarted", "InquiryOk", "InquiryNotOk", "NoResponse", "Unmatched", "Unsuccessful"];
    }
}

export function PortationStatus$reflection() {
    return union_type("DomainTypes.PortationStatus", [], PortationStatus, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function PortationStatusModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "Activation Started";
        }
        case 2: {
            return "Cancellation Started";
        }
        case 3: {
            return "Cancel Ok";
        }
        case 4: {
            return "Cancel Not Ok";
        }
        case 5: {
            return "Cancelled";
        }
        case 6: {
            return "Change Ok";
        }
        case 7: {
            return "Change Not Ok";
        }
        case 8: {
            return "Change Started";
        }
        case 9: {
            return "Changed";
        }
        case 10: {
            return "Old";
        }
        case 11: {
            return "Ordered";
        }
        case 12: {
            return "OrderOk";
        }
        case 13: {
            return "Order Started";
        }
        case 14: {
            return "Inquiry Started";
        }
        case 15: {
            return "Inquiry Ok";
        }
        case 16: {
            return "Inquiry Not Ok";
        }
        case 17: {
            return "No Response";
        }
        case 18: {
            return "Unmatched";
        }
        case 19: {
            return "Unsuccessful";
        }
        default: {
            return "Activated";
        }
    }
}

export function PortationStatusModule_fromString(str) {
    const formattedString = replace(replace(str, "_", ""), " ", "").toLocaleUpperCase();
    switch (formattedString) {
        case "ACTIVATED": {
            return new PortationStatus(0);
        }
        case "ACTIVATIONSTARTED": {
            return new PortationStatus(1);
        }
        case "CANCELLATIONSTARTED": {
            return new PortationStatus(2);
        }
        case "CANCELOK": {
            return new PortationStatus(3);
        }
        case "CANCELNOTOK": {
            return new PortationStatus(4);
        }
        case "CANCELLED": {
            return new PortationStatus(5);
        }
        case "CHANGEOK": {
            return new PortationStatus(6);
        }
        case "CHANGENOTOK": {
            return new PortationStatus(7);
        }
        case "CHANGESTARTED": {
            return new PortationStatus(8);
        }
        case "CHANGED": {
            return new PortationStatus(9);
        }
        case "OLD": {
            return new PortationStatus(10);
        }
        case "ORDERED": {
            return new PortationStatus(11);
        }
        case "ORDEROK": {
            return new PortationStatus(12);
        }
        case "ORDERSTARTED": {
            return new PortationStatus(13);
        }
        case "INQUIRYSTARTED": {
            return new PortationStatus(14);
        }
        case "INQUIRYOK": {
            return new PortationStatus(15);
        }
        case "INQUIRYNOTOK": {
            return new PortationStatus(16);
        }
        case "NORESPONSE": {
            return new PortationStatus(17);
        }
        case "UNMATCHED": {
            return new PortationStatus(18);
        }
        case "UNSUCCESSFUL": {
            return new PortationStatus(19);
        }
        default: {
            return toFail(printf("[PortationStatus.fromString] Can not parse: %s"))(formattedString);
        }
    }
}

export function PortationStatusModule_fromByte(code) {
    switch (code) {
        case 1: {
            return new PortationStatus(0);
        }
        case 2: {
            return new PortationStatus(1);
        }
        case 3: {
            return new PortationStatus(2);
        }
        case 4: {
            return new PortationStatus(3);
        }
        case 5: {
            return new PortationStatus(4);
        }
        case 6: {
            return new PortationStatus(5);
        }
        case 7: {
            return new PortationStatus(6);
        }
        case 8: {
            return new PortationStatus(7);
        }
        case 9: {
            return new PortationStatus(8);
        }
        case 10: {
            return new PortationStatus(9);
        }
        case 11: {
            return new PortationStatus(10);
        }
        case 12: {
            return new PortationStatus(11);
        }
        case 13: {
            return new PortationStatus(12);
        }
        case 14: {
            return new PortationStatus(13);
        }
        case 15: {
            return new PortationStatus(14);
        }
        case 16: {
            return new PortationStatus(15);
        }
        case 17: {
            return new PortationStatus(16);
        }
        case 18: {
            return new PortationStatus(17);
        }
        case 19: {
            return new PortationStatus(18);
        }
        case 20: {
            return new PortationStatus(19);
        }
        default: {
            return toFail(printf("[PortationStatus.fromByte] Can not parse: %i"))(code);
        }
    }
}

export function PortationStatusModule_toInportingState(_arg) {
    switch (_arg.tag) {
        case 0: {
            return new InportingState(8);
        }
        case 1:
        case 4:
        case 6:
        case 7:
        case 8:
        case 9:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 17: {
            return new InportingState(1);
        }
        case 2: {
            return new InportingState(9);
        }
        case 3:
        case 5: {
            return new InportingState(10);
        }
        case 19:
        case 16:
        case 18: {
            return new InportingState(11);
        }
        default: {
            return new InportingState(8);
        }
    }
}

export class InvoiceeState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Active", "ActiveWithEndDate", "Cancelled", "Pending", "NoContracts", "Inconsistent"];
    }
}

export function InvoiceeState$reflection() {
    return union_type("DomainTypes.InvoiceeState", [], InvoiceeState, () => [[], [], [], [], [], []]);
}

export function InvoiceeStateModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "Active with enddate";
        }
        case 2: {
            return "Cancelled";
        }
        case 3: {
            return "Pending";
        }
        case 4: {
            return "No contracts";
        }
        case 5: {
            return "Inconsistent";
        }
        default: {
            return "Active";
        }
    }
}

export function InvoiceeStateModule_ofString(_arg) {
    switch (_arg) {
        case InvoiceeStateModule_toString(new InvoiceeState(0)): {
            return new InvoiceeState(0);
        }
        case InvoiceeStateModule_toString(new InvoiceeState(1)): {
            return new InvoiceeState(1);
        }
        case InvoiceeStateModule_toString(new InvoiceeState(2)): {
            return new InvoiceeState(2);
        }
        case InvoiceeStateModule_toString(new InvoiceeState(3)): {
            return new InvoiceeState(3);
        }
        case InvoiceeStateModule_toString(new InvoiceeState(4)): {
            return new InvoiceeState(4);
        }
        default: {
            return new InvoiceeState(5);
        }
    }
}

export function InvoiceeStateModule_toTranslation(getTranslation, _arg) {
    switch (_arg.tag) {
        case 1: {
            return getTranslation("Common.ActiveWithEndDate");
        }
        case 2: {
            return getTranslation("Common.Cancelled");
        }
        case 3: {
            return getTranslation("Common.Pending");
        }
        case 4: {
            return getTranslation("DomainTypes.InvoiceeState.NoSubscriptions");
        }
        case 5: {
            return getTranslation("Common.Inconsistent");
        }
        default: {
            return getTranslation("Common.Active");
        }
    }
}

export class BillingIntervalUnit extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Monthly", "Yearly"];
    }
}

export function BillingIntervalUnit$reflection() {
    return union_type("DomainTypes.BillingIntervalUnit", [], BillingIntervalUnit, () => [[], []]);
}

export function BillingIntervalUnitModule_fromString(_arg) {
    switch (_arg) {
        case "M": {
            return new BillingIntervalUnit(0);
        }
        case "Y": {
            return new BillingIntervalUnit(1);
        }
        default: {
            return toFail(printf("[BillingIntervalUnit] Cannot convert string \u0027%s \u0027to BillingIntervalUnit."))(_arg);
        }
    }
}

export function BillingIntervalUnitModule_toString(_arg) {
    if (_arg.tag === 1) {
        return "Y";
    }
    else {
        return "M";
    }
}

export function BillingIntervalUnitModule_toTranslation(getTranslation, _arg) {
    if (_arg.tag === 1) {
        return getTranslation("Common.Year");
    }
    else {
        return getTranslation("Common.Month");
    }
}

export class BillingInterval extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["MonthInterval", "QuarterInterval", "HalfYearInterval", "YearInterval", "OtherInterval"];
    }
}

export function BillingInterval$reflection() {
    return union_type("DomainTypes.BillingInterval", [], BillingInterval, () => [[], [], [], [], [["Item", int32_type]]]);
}

export function BillingIntervalModule_fromString(_arg) {
    switch (_arg) {
        case "1": {
            return new BillingInterval(0);
        }
        case "3": {
            return new BillingInterval(1);
        }
        case "6": {
            return new BillingInterval(2);
        }
        case "12": {
            return new BillingInterval(3);
        }
        default: {
            return new BillingInterval(4, parse(_arg, 511, false, 32));
        }
    }
}

export function BillingIntervalModule_fromInt(_arg) {
    switch (_arg) {
        case 1: {
            return new BillingInterval(0);
        }
        case 3: {
            return new BillingInterval(1);
        }
        case 6: {
            return new BillingInterval(2);
        }
        case 12: {
            return new BillingInterval(3);
        }
        default: {
            return new BillingInterval(4, _arg);
        }
    }
}

export function BillingIntervalModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1: {
            return 3;
        }
        case 2: {
            return 6;
        }
        case 3: {
            return 12;
        }
        case 4: {
            return _arg.fields[0] | 0;
        }
        default: {
            return 1;
        }
    }
}

export function BillingIntervalModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "3";
        }
        case 2: {
            return "6";
        }
        case 3: {
            return "12";
        }
        case 4: {
            return int32ToString(_arg.fields[0]);
        }
        default: {
            return "1";
        }
    }
}

export function BillingIntervalModule_toTranslation(getTranslation, _arg) {
    switch (_arg.tag) {
        case 1: {
            return getTranslation("CustomerContract.RegisterInvoicee.Common.Quarter");
        }
        case 2: {
            return getTranslation("CustomerContract.RegisterInvoicee.Common.HalfYear");
        }
        case 3: {
            return getTranslation("CustomerContract.RegisterInvoicee.Common.Year");
        }
        case 4: {
            const arg_1 = getTranslation("CustomerContract.RegisterInvoicee.Common.Month");
            return toText(printf("%i %s"))(_arg.fields[0])(arg_1);
        }
        default: {
            return getTranslation("CustomerContract.RegisterInvoicee.Common.Month");
        }
    }
}

export function BillingIntervalModule_getMonthlyBillingIntervalOptions(getTranslation) {
    return ofArray([["1", getTranslation("CustomerContract.RegisterInvoicee.Common.Month")], ["3", getTranslation("CustomerContract.RegisterInvoicee.Common.Quarter")], ["6", getTranslation("CustomerContract.RegisterInvoicee.Common.HalfYear")], ["12", getTranslation("CustomerContract.RegisterInvoicee.Common.Year")]]);
}

export class FormLayout extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Simple", "Advanced"];
    }
}

export function FormLayout$reflection() {
    return union_type("DomainTypes.FormLayout", [], FormLayout, () => [[], []]);
}

export function FormLayoutModule_fromString(_arg) {
    switch (_arg) {
        case "Simple": {
            return new FormLayout(0);
        }
        case "Advanced": {
            return new FormLayout(1);
        }
        default: {
            return toFail(printf("[FormLayout] Cannot convert string \u0027%s \u0027to FormLayout."))(_arg);
        }
    }
}

export function FormLayoutModule_toString(_arg) {
    if (_arg.tag === 1) {
        return "Advanced";
    }
    else {
        return "Simple";
    }
}

export class PaymentStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["UNPAID", "LOSS", "CREDITED", "TERMINATED", "PARTIALLY_PAID", "PARTIALLY_PAID_WITH_A_LOSS", "PARTIALLY_PAID_WITH_A_CREDITED", "PARTIALLY_PAID_WITH_A_TERMINATED", "PAID", "PAID_WITH_A_LOSS", "PAID_WITH_A_CREDITED", "PAID_WITH_A_TERMINATED", "UNKNOWN"];
    }
}

export function PaymentStatus$reflection() {
    return union_type("DomainTypes.PaymentStatus", [], PaymentStatus, () => [[], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function PaymentStatusModule_fromString(_arg) {
    switch (_arg) {
        case "UNPAID": {
            return new PaymentStatus(0);
        }
        case "LOSS": {
            return new PaymentStatus(1);
        }
        case "CREDITED": {
            return new PaymentStatus(2);
        }
        case "TERMINATED": {
            return new PaymentStatus(3);
        }
        case "PARTIALLY_PAID": {
            return new PaymentStatus(4);
        }
        case "PARTIALLY_PAID_WITH_A_LOSS": {
            return new PaymentStatus(5);
        }
        case "PARTIALLY_PAID_WITH_A_CREDITED": {
            return new PaymentStatus(6);
        }
        case "PARTIALLY_PAID_WITH_A_TERMINATED": {
            return new PaymentStatus(7);
        }
        case "PAID": {
            return new PaymentStatus(8);
        }
        case "PAID_WITH_A_LOSS": {
            return new PaymentStatus(9);
        }
        case "PAID_WITH_A_CREDITED": {
            return new PaymentStatus(10);
        }
        case "PAID_WITH_A_TERMINATED": {
            return new PaymentStatus(11);
        }
        case "UNKNOWN": {
            return new PaymentStatus(12);
        }
        default: {
            return toFail(printf("[PaymentStatus] fromString: Unknown payment status: %s"))(_arg);
        }
    }
}

export function PaymentStatusModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "LOSS";
        }
        case 2: {
            return "CREDITED";
        }
        case 3: {
            return "TERMINATED";
        }
        case 4: {
            return "PARTIALLY_PAID";
        }
        case 5: {
            return "PARTIALLY_PAID_WITH_A_LOSS";
        }
        case 6: {
            return "PARTIALLY_PAID_WITH_A_CREDITED";
        }
        case 7: {
            return "PARTIALLY_PAID_WITH_A_TERMINATED";
        }
        case 8: {
            return "PAID";
        }
        case 9: {
            return "PAID_WITH_A_LOSS";
        }
        case 10: {
            return "PAID_WITH_A_CREDITED";
        }
        case 11: {
            return "PAID_WITH_A_TERMINATED";
        }
        case 12: {
            return "UNKNOWN";
        }
        default: {
            return "UNPAID";
        }
    }
}

export function PaymentStatusModule_toTranslation(getTranslation, _arg) {
    switch (_arg.tag) {
        case 1: {
            return getTranslation("DomainTypes.PaymentStatus.Loss");
        }
        case 2: {
            return getTranslation("DomainTypes.PaymentStatus.Credited");
        }
        case 3: {
            return getTranslation("DomainTypes.PaymentStatus.Terminated");
        }
        case 4: {
            return getTranslation("DomainTypes.PaymentStatus.PartiallyPaid");
        }
        case 5: {
            return getTranslation("DomainTypes.PaymentStatus.PartiallyPaidWithALoss");
        }
        case 6: {
            return getTranslation("DomainTypes.PaymentStatus.PartiallyPaidWithACredited");
        }
        case 7: {
            return getTranslation("DomainTypes.PaymentStatus.PartiallyPaidWithATerminated");
        }
        case 8: {
            return getTranslation("DomainTypes.PaymentStatus.Paid");
        }
        case 9: {
            return getTranslation("DomainTypes.PaymentStatus.PaidWithALoss");
        }
        case 10: {
            return getTranslation("DomainTypes.PaymentStatus.PaidWithACredited");
        }
        case 11: {
            return getTranslation("DomainTypes.PaymentStatus.PaidWithATerminated");
        }
        case 12: {
            return getTranslation("Common.Unknown");
        }
        default: {
            return getTranslation("DomainTypes.PaymentStatus.Unpaid");
        }
    }
}

export class ClaimStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["EMPTY", "CLAIMSTOPPED", "REMINDER_SOFT", "OVERDUE", "REMINDER_1", "COLLECTION_CANCELLED", "COLLECTION_PROPOSAL", "COLLECTION", "UNKOWN"];
    }
}

export function ClaimStatus$reflection() {
    return union_type("DomainTypes.ClaimStatus", [], ClaimStatus, () => [[], [], [], [], [], [], [], [], []]);
}

export function ClaimStatusModule_fromString(_arg) {
    switch (_arg) {
        case "":
        case "EMPTY": {
            return new ClaimStatus(0);
        }
        case "CLAIMSTOPPED": {
            return new ClaimStatus(1);
        }
        case "REMINDER_SOFT": {
            return new ClaimStatus(2);
        }
        case "OVERDUE": {
            return new ClaimStatus(3);
        }
        case "REMINDER_1": {
            return new ClaimStatus(4);
        }
        case "COLLECTION_CANCELLED": {
            return new ClaimStatus(5);
        }
        case "COLLECTION_PROPOSAL": {
            return new ClaimStatus(6);
        }
        case "COLLECTION": {
            return new ClaimStatus(7);
        }
        case "UNKOWN": {
            return new ClaimStatus(8);
        }
        default: {
            return toFail(printf("[ClaimStatus] fromString: Unknown claim status: %s"))(_arg);
        }
    }
}

export function ClaimStatusModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "CLAIMSTOPPED";
        }
        case 2: {
            return "REMINDER_SOFT";
        }
        case 3: {
            return "OVERDUE";
        }
        case 4: {
            return "REMINDER_1";
        }
        case 5: {
            return "COLLECTION_CANCELLED";
        }
        case 6: {
            return "COLLECTION_PROPOSAL";
        }
        case 7: {
            return "COLLECTION";
        }
        case 8: {
            return "UNKOWN";
        }
        default: {
            return "";
        }
    }
}

export function ClaimStatusModule_toTranslation(getTranslation, _arg) {
    switch (_arg.tag) {
        case 1: {
            return getTranslation("DomainTypes.ClaimStatus.ClaimStopped");
        }
        case 2: {
            return getTranslation("DomainTypes.ClaimStatus.ReminderSoft");
        }
        case 3: {
            return getTranslation("DomainTypes.ClaimStatus.Overdue");
        }
        case 4: {
            return getTranslation("DomainTypes.ClaimStatus.Reminder1");
        }
        case 5: {
            return getTranslation("DomainTypes.ClaimStatus.CollectionCancelled");
        }
        case 6: {
            return getTranslation("DomainTypes.ClaimStatus.CollectionProposal");
        }
        case 7: {
            return getTranslation("DomainTypes.ClaimStatus.Collection");
        }
        case 8: {
            return getTranslation("Common.Unknown");
        }
        default: {
            return "";
        }
    }
}

export class TransactionTypeDesc extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["EMPTY", "BANKGIRO", "KASSA_OR_CHECK", "POSTGIRO", "POSTGIRO_OCR", "BANKGIRO_OCR", "INKASSO_KAPITAL", "KUNDFORLUST", "BETALD_TILL_UG", "DEBET_OR_KREDIT", "BORTSKRIVNING", "UNKNOWN"];
    }
}

export function TransactionTypeDesc$reflection() {
    return union_type("DomainTypes.TransactionTypeDesc", [], TransactionTypeDesc, () => [[], [], [], [], [], [], [], [], [], [], [], []]);
}

export function TransactionTypeDescModule_fromString(_arg) {
    switch (_arg) {
        case "":
        case "EMPTY": {
            return new TransactionTypeDesc(0);
        }
        case "BANKGIRO": {
            return new TransactionTypeDesc(1);
        }
        case "KASSA_OR_CHECK": {
            return new TransactionTypeDesc(2);
        }
        case "POSTGIRO": {
            return new TransactionTypeDesc(3);
        }
        case "POSTGIRO_OCR": {
            return new TransactionTypeDesc(4);
        }
        case "BANKGIRO_OCR": {
            return new TransactionTypeDesc(5);
        }
        case "INKASSO_KAPITAL": {
            return new TransactionTypeDesc(6);
        }
        case "KUNDFORLUST": {
            return new TransactionTypeDesc(7);
        }
        case "BETALD_TILL_UG": {
            return new TransactionTypeDesc(8);
        }
        case "DEBET_OR_KREDIT": {
            return new TransactionTypeDesc(9);
        }
        case "BORTSKRIVNING": {
            return new TransactionTypeDesc(10);
        }
        case "UNKOWN": {
            return new TransactionTypeDesc(11);
        }
        default: {
            return toFail(printf("[TransactionTypeDesc] fromString: Unknown TransactionTypeDesc: %s"))(_arg);
        }
    }
}

export function TransactionTypeDescModule_fromInt(_arg) {
    switch (_arg) {
        case 10: {
            return new TransactionTypeDesc(1);
        }
        case 11: {
            return new TransactionTypeDesc(2);
        }
        case 12: {
            return new TransactionTypeDesc(3);
        }
        case 16: {
            return new TransactionTypeDesc(4);
        }
        case 17: {
            return new TransactionTypeDesc(5);
        }
        case 20: {
            return new TransactionTypeDesc(6);
        }
        case 31: {
            return new TransactionTypeDesc(7);
        }
        case 32: {
            return new TransactionTypeDesc(8);
        }
        case 33: {
            return new TransactionTypeDesc(9);
        }
        case 34: {
            return new TransactionTypeDesc(10);
        }
        default: {
            return new TransactionTypeDesc(11);
        }
    }
}

export function TransactionTypeDescModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "BANKGIRO";
        }
        case 2: {
            return "KASSA_OR_CHECK";
        }
        case 3: {
            return "POSTGIRO";
        }
        case 4: {
            return "POSTGIRO_OCR";
        }
        case 5: {
            return "BANKGIRO_OCR";
        }
        case 6: {
            return "INKASSO_KAPITAL";
        }
        case 7: {
            return "KUNDFORLUST";
        }
        case 8: {
            return "BETALD_TILL_UG";
        }
        case 9: {
            return "DEBET_OR_KREDIT";
        }
        case 10: {
            return "BORTSKRIVNING";
        }
        case 11: {
            return "UNKOWN";
        }
        default: {
            return "";
        }
    }
}

export function TransactionTypeDescModule_toTranslation(getTranslation, _arg) {
    switch (_arg.tag) {
        case 1: {
            return getTranslation("DomainTypes.TransactionTypeDesc.Bankgiro");
        }
        case 2: {
            return getTranslation("DomainTypes.TransactionTypeDesc.KassaOrCheck");
        }
        case 3: {
            return getTranslation("DomainTypes.TransactionTypeDesc.Postgiro");
        }
        case 4: {
            return getTranslation("DomainTypes.TransactionTypeDesc.PostgiroOcr");
        }
        case 5: {
            return getTranslation("DomainTypes.TransactionTypeDesc.BankgiroOcr");
        }
        case 6: {
            return getTranslation("DomainTypes.TransactionTypeDesc.InkassoKapital");
        }
        case 7: {
            return getTranslation("DomainTypes.TransactionTypeDesc.Kundforlust");
        }
        case 8: {
            return getTranslation("DomainTypes.TransactionTypeDesc.BetaldTillUg");
        }
        case 9: {
            return getTranslation("DomainTypes.TransactionTypeDesc.DebitOrCredit");
        }
        case 10: {
            return getTranslation("DomainTypes.TransactionTypeDesc.Bortskrivning");
        }
        case 11: {
            return getTranslation("Common.Unknown");
        }
        default: {
            return "";
        }
    }
}

export class Month extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    }
}

export function Month$reflection() {
    return union_type("DomainTypes.Month", [], Month, () => [[], [], [], [], [], [], [], [], [], [], [], []]);
}

export function MonthModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "February";
        }
        case 2: {
            return "March";
        }
        case 3: {
            return "April";
        }
        case 4: {
            return "May";
        }
        case 5: {
            return "June";
        }
        case 6: {
            return "July";
        }
        case 7: {
            return "August";
        }
        case 8: {
            return "September";
        }
        case 9: {
            return "October";
        }
        case 10: {
            return "November";
        }
        case 11: {
            return "December";
        }
        default: {
            return "January";
        }
    }
}

export function MonthModule_toTranslation(getTranslation, _arg) {
    switch (_arg.tag) {
        case 1: {
            return getTranslation("Common.Month.February");
        }
        case 2: {
            return getTranslation("Common.Month.March");
        }
        case 3: {
            return getTranslation("Common.Month.April");
        }
        case 4: {
            return getTranslation("Common.Month.May");
        }
        case 5: {
            return getTranslation("Common.Month.June");
        }
        case 6: {
            return getTranslation("Common.Month.July");
        }
        case 7: {
            return getTranslation("Common.Month.August");
        }
        case 8: {
            return getTranslation("Common.Month.September");
        }
        case 9: {
            return getTranslation("Common.Month.October");
        }
        case 10: {
            return getTranslation("Common.Month.November");
        }
        case 11: {
            return getTranslation("Common.Month.December");
        }
        default: {
            return getTranslation("Common.Month.January");
        }
    }
}

export function MonthModule_fromString(_arg) {
    switch (_arg) {
        case "January": {
            return new Month(0);
        }
        case "February": {
            return new Month(1);
        }
        case "March": {
            return new Month(2);
        }
        case "April": {
            return new Month(3);
        }
        case "May": {
            return new Month(4);
        }
        case "June": {
            return new Month(5);
        }
        case "July": {
            return new Month(6);
        }
        case "August": {
            return new Month(7);
        }
        case "September": {
            return new Month(8);
        }
        case "October": {
            return new Month(9);
        }
        case "November": {
            return new Month(10);
        }
        case "December": {
            return new Month(11);
        }
        default: {
            return toFail(printf("[Month] Cannot parse month: \u0027%s\u0027."))(_arg);
        }
    }
}

export function MonthModule_fromInt(_arg) {
    switch (_arg) {
        case 1: {
            return new Month(0);
        }
        case 2: {
            return new Month(1);
        }
        case 3: {
            return new Month(2);
        }
        case 4: {
            return new Month(3);
        }
        case 5: {
            return new Month(4);
        }
        case 6: {
            return new Month(5);
        }
        case 7: {
            return new Month(6);
        }
        case 8: {
            return new Month(7);
        }
        case 9: {
            return new Month(8);
        }
        case 10: {
            return new Month(9);
        }
        case 11: {
            return new Month(10);
        }
        case 12: {
            return new Month(11);
        }
        default: {
            return toFail(printf("[Month] Cannot parse month: \u0027%i\u0027"))(_arg);
        }
    }
}

export function NoNextInvoice_getNoNextInvoiceOptions(getTranslation) {
    return ofArray([["false", getTranslation("Common.Yes")], ["true", getTranslation("Common.No")]]);
}

export function NoNextInvoice_toTranslation(getTranslation, _arg) {
    if (_arg) {
        return getTranslation("Common.No");
    }
    else {
        return getTranslation("Common.Yes");
    }
}

export function NoNextInvoice_toString(_arg) {
    if (_arg) {
        return "true";
    }
    else {
        return "false";
    }
}

export function NoNextInvoice_toBool(str) {
    switch (str) {
        case "false": {
            return true;
        }
        case "true": {
            return false;
        }
        default: {
            throw (new Error(toText(printf("[noNextInvoiceToBool] Cannot parse \u0027%s\u0027 into bool."))(str)));
        }
    }
}

export class InvoiceePaymentState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["StoppedForReminder", "Reminder1", "DebtCollection1", "DebtCollection2", "DebtCollection2Plus", "Blank", "Other"];
    }
}

export function InvoiceePaymentState$reflection() {
    return union_type("DomainTypes.InvoiceePaymentState", [], InvoiceePaymentState, () => [[], [], [], [], [], [], [["Item", string_type]]]);
}

export function InvoiceePaymentStateModule_fromString(_arg) {
    switch (_arg) {
        case "Stopped for reminder": {
            return new InvoiceePaymentState(0);
        }
        case "Reminder 1": {
            return new InvoiceePaymentState(1);
        }
        case "Debt collection 1": {
            return new InvoiceePaymentState(2);
        }
        case "Debt collection 2": {
            return new InvoiceePaymentState(3);
        }
        case "Debt collection 2+": {
            return new InvoiceePaymentState(4);
        }
        case "": {
            return new InvoiceePaymentState(5);
        }
        default: {
            return new InvoiceePaymentState(6, _arg);
        }
    }
}

export function InvoiceePaymentStateModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "Reminder 1";
        }
        case 2: {
            return "Debt collection 1";
        }
        case 3: {
            return "Debt collection 2";
        }
        case 4: {
            return "Debt collection 2+";
        }
        case 5: {
            return "";
        }
        case 6: {
            return _arg.fields[0];
        }
        default: {
            return "Stopped for reminder";
        }
    }
}

export class TerminationState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Nothing", "ALERT", "HOLD", "TERMINATED", "TERMINATING", "WARNING", "Other"];
    }
}

export function TerminationState$reflection() {
    return union_type("DomainTypes.TerminationState", [], TerminationState, () => [[], [], [], [], [], [], [["Item", string_type]]]);
}

export function TerminationStateModule_fromString(_arg) {
    switch (_arg) {
        case "Nothing":
        case "": {
            return new TerminationState(0);
        }
        case "ALERT": {
            return new TerminationState(1);
        }
        case "HOLD": {
            return new TerminationState(2);
        }
        case "TERMINATED": {
            return new TerminationState(3);
        }
        case "TERMINATING": {
            return new TerminationState(4);
        }
        case "WARNING": {
            return new TerminationState(5);
        }
        default: {
            return new TerminationState(6, _arg);
        }
    }
}

export function TerminationStateModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "ALERT";
        }
        case 2: {
            return "HOLD";
        }
        case 3: {
            return "TERMINATED";
        }
        case 4: {
            return "TERMINATING";
        }
        case 5: {
            return "WARNING";
        }
        case 6: {
            return _arg.fields[0];
        }
        default: {
            return "";
        }
    }
}

export function MonthsInAdvance_toTranslation(getTranslation, number) {
    const months = getTranslation("Common.Months");
    switch (number) {
        case 0: {
            return getTranslation("Common.Nothing");
        }
        case 1: {
            return "1 " + getTranslation("Common.Month");
        }
        default: {
            return toText(printf("%i %s"))(number)(months);
        }
    }
}

export function CancellationPeriodMonths_toTranslation(getTranslation, number) {
    const months = getTranslation("Common.Months");
    switch (number) {
        case 0: {
            return getTranslation("Common.Nothing");
        }
        case 1: {
            return "1 " + getTranslation("Common.Month");
        }
        default: {
            return toText(printf("%i %s"))(number)(months);
        }
    }
}

